import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import UserSelect from '../Users/UserSelect'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { observer } from 'mobx-react';
import Button from '@mui/material/Button';
import { ColorPicker } from 'material-ui-color';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import authStore from '../../Auth/AuthStore'
import mainStore from '../../../MainStore'
import ProjectStatistic from './ProjectStatistic'
import GroupSelectBlock from './GroupSelectBlock'
import ProjectEnvironments from './ProjectEnvironments'
import Participants from './Participants'
import './projects.css'
import ProjectStatusSelect from './ProjectStatusSelect';
import AccountSelect from '../Kanban/AccountSelect';
import Paper from '@mui/material/Paper';
import ProjectTypeSelect from './ProjectTypeSelect';
import ProjectStages from './ProjectStages';
import ProjectProducts from './ProjectProducts';
import ProjectServices from './ProjectServices';
import ProductSelect from './ProductSelect';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';

const EnvironmentProductDialog = observer(class EnvironmentProductDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleChange = name => evt => {
        var v = mainStore.openedEnvironmentProduct;
        v[name] = evt.target.value;
        mainStore.setOpenedEnvironmentProduct(v);
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        fetchWithAuth(
            'api/Environment/SaveEnvironmentProduct',
            JSON.stringify(mainStore.openedEnvironmentProduct)
            ,
            'application/json',
            (result) => {
                if (mainStore.productCallback) {
                    mainStore.productCallback(result);
                    mainStore.setProductCallback(() => { });
                }
                mainStore.closeEnvironmentProductDialog();
                mainStore.setMaskUnvisible();
            },
            'POST'
        );
    }

    handleClose() {
        mainStore.closeEnvironmentProductDialog();
    }

    handleProductChange(product) {
        var v = mainStore.openedEnvironmentProduct;
        v.productId = !!product ? product.id : '';
        v.productName = !!product ? product.name : '';
        mainStore.setOpenedEnvironmentProduct(v);
    }

    render() {
        if (!this.props) {
            return <div></div>
        }

        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={mainStore.isEnvironmentProductDialogOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="customized-dialog-title">
                    Продукт среды
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        <ProductSelect handleSelect={this.handleProductChange} id={mainStore.openedEnvironmentProduct.productId} name={mainStore.openedEnvironmentProduct.productName}/>
                    </Typography>
                    <Typography>
                        <TextField
                            id="version"
                            label="Версия"
                            fullWidth
                            margin="normal"
                            value={mainStore.openedEnvironmentProduct.version}
                            onChange={this.handleChange('version')}
                        />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleSave} color="primary">
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
});

export default EnvironmentProductDialog;